class Wishlist {
  constructor() {
    this.storageKey = 'shopify_wishlist';
    this.wishlistItems = this.getWishlist();
    this.init();
  }

  init() {
    this.updateWishlistCount();
    this.bindEvents();
    this.updateAllButtons();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      // Verifica se clicou no botão wishlist (card ou produto)
      const btn = e.target.closest('.wishlist-btn, .wishlist-btn-prod');
      
      if (btn) {
        e.preventDefault();
        const productId = btn.dataset.productId;
        const productTitle = btn.dataset.productTitle;
        const productImage = btn.dataset.productImage;
        const productUrl = btn.dataset.productUrl;
        const productPrice = btn.dataset.productPrice;
        
        this.toggleWishlist({
          id: productId,
          title: productTitle,
          image: productImage,
          url: productUrl,
          price: productPrice
        });
      }
    });
  }

  getWishlist() {
    const wishlist = localStorage.getItem(this.storageKey);
    return wishlist ? JSON.parse(wishlist) : [];
  }

  saveWishlist() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.wishlistItems));
  }

  toggleWishlist(product) {
    const index = this.wishlistItems.findIndex(item => item.id === product.id);
    
    if (index > -1) {
      this.wishlistItems.splice(index, 1);
    } else {
      this.wishlistItems.push(product);
    }
    
    this.saveWishlist();
    this.updateAllButtons();
    this.updateWishlistCount();
    this.showNotification(index > -1 ? 'removed' : 'added');
  }

  isInWishlist(productId) {
    return this.wishlistItems.some(item => item.id === productId);
  }

  updateAllButtons() {
    // Seleciona todos os botões de wishlist (card e produto)
    const buttons = document.querySelectorAll('.wishlist-btn, .wishlist-btn-prod');
    
    buttons.forEach(btn => {
      const productId = btn.dataset.productId;
      
      if (this.isInWishlist(productId)) {
        btn.classList.add('active');
        btn.setAttribute('aria-label', 'Remover da wishlist');
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-label', 'Adicionar à wishlist');
      }
    });
  }

  updateWishlistCount() {
    const countElements = document.querySelectorAll('.wishlist-count');
    countElements.forEach(el => {
      el.textContent = this.wishlistItems.length;
      el.style.display = this.wishlistItems.length > 0 ? 'flex' : 'none';
    });
  }

  showNotification(action) {
    const message = action === 'added' 
      ? 'Produto adicionado à wishlist!' 
      : 'Produto removido da wishlist!';
    
    const notification = document.createElement('div');
    notification.className = 'wishlist-notification';
    notification.textContent = message;
    document.body.appendChild(notification);
    
    setTimeout(() => notification.classList.add('show'), 100);
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  getWishlistItems() {
    return this.wishlistItems;
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.wishlist = new Wishlist();
  });
} else {
  window.wishlist = new Wishlist();
}